import React from 'react';
import StyledLinkContainer from './handles/StyledLinkContainer';
import StyledLink from './handles/StyledLink';
import StyledLinkContent from './handles/StyledLinkContent';
import { useOrientation } from '../Menu/hooks/useMenu';
import { useCssHandles } from '../../../utils/functions';

const CSS_HANDLES = ['menuItem', 'menuItemInnerDiv'];
const MenuItem = (props) => {
	const { handles, withModifiers } = useCssHandles('vtex-menu-2-x', CSS_HANDLES, props.blockClass);
	const [isActive, setActive] = React.useState(props.onMountBehavior === 'open' ? true : false);
	const classes = withModifiers('menuItem', isActive ? 'isOpen' : 'isClosed');
	const [menuItemClass, setMenuItemClass] = React.useState(classes);
	const { orientation } = useOrientation();
	const [isHovered, setHovered] = React.useState(false);
	//check if any block has the componentGroup as submenuAccordion
	const isCollapsible = props.blocks?.find((block) => block?.props?.comp?.componentName == 'SubmenuAccordion');

	React.useEffect(() => {
		const isOpen = isHovered || isActive;
		setMenuItemClass(withModifiers('menuItem', isOpen ? 'isOpen' : 'isClosed'));
	}, [isHovered, props.onMountBehavior, isActive]);

	if (isCollapsible) {
		return (
			<li data-selection={props.componentId} className={`${handles.menuItem} ${menuItemClass}`}>
				<div
					className={handles.menuItemInnerDiv}
					onClick={(evt) => {
						setActive(!isActive);
					}}
				>
					<StyledLinkContainer orientation={orientation} blockClass={props.blockClass}>
						<StyledLink {...props}>
							<StyledLinkContent {...props} isOpen={isHovered || isActive} isCollapsible={isCollapsible} />
						</StyledLink>
					</StyledLinkContainer>
				</div>
				{isActive && props.blocks && <>{props.blocks}</>}
			</li>
		);
	}

	return (
		<li
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
			data-selection={props.componentId}
			className={`${handles.menuItem} ${menuItemClass}`}
		>
			<StyledLinkContainer orientation={orientation} blockClass={props.blockClass}>
				<StyledLink {...props}>
					<StyledLinkContent {...props} />
				</StyledLink>
			</StyledLinkContainer>
			{isHovered && props.blocks && <>{props.blocks}</>}
		</li>
	);
};

export default MenuItem;
